// DO NOT EDIT MANUALLY!
// This file is generated, edit `resources/Localizations.json` and run `npm run generate-translation-keys` to update.

export enum TranslationKeys {
  buy = 'buy',
  choose = 'choose',
  inclusiveOfAllTaxes = 'inclusiveOfAllTaxes',
  lowestPriceText = 'lowestPriceText',
  newEdition = 'newEdition',
  newEditionAvailable = 'newEditionAvailable',
  replace = 'replace',
  replaceWith = 'replaceWith',
  reserve = 'reserve',
  save = 'save',
}
